import styled from "styled-components"

export const StyledHerroOfferWrapper = styled.div`
  padding: 94px 0 0 151px;
  @media only screen and (max-width: 767px) {
    h1 {
      font-size: 36px;
    }
    p {
      font-size: 14px;
      line-height: 1.75em;
      max-width: 276px;
    }
  }
  @media only screen and (max-width: 641px) {
    padding: 94px 0 0 40px;
  }
`
